import React from 'react';
import PasswordUpdateLeftPanel from '../PasswordUpdateLeftPanel/PasswordUpdateLeftPanel';
import PaswwordUpdateRightPanel from '../PaswwordUpdateRightPanel/PaswwordUpdateRightPanel';

const PasswordUpdateBody = () => {
  return (
    <section className="feed_pnltotal">
      <div className="container-fluid">
        <div className="pnl_outer profile_pnlOuter">
          <PasswordUpdateLeftPanel moduleName="password" />
          <PaswwordUpdateRightPanel />
        </div>
      </div>
    </section>
  );
};

export default PasswordUpdateBody;
